import HttpRequest from './HttpRequest'

class FormTemplateProvider extends HttpRequest {
  findAll () {
    return this.get('/form-template')
  }

  findOne (id) {
    return this.get(`/form-template/${id}`)
  }

  create (payload) {
    return this.post('/form-template', payload)
  }

  update (id, payload) {
    return this.patch(`/form-template/${id}`, payload)
  }

  softDelete (id) {
    return this.delete(`/form-template/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/form-template?page=${page}&limit=${limit}`, query)
  }
}

export default FormTemplateProvider
